export const R_BADGE = '<sup>®</sup>';

const RBadge = () => <sup>®</sup>;

export default RBadge;
